(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9335],{

/***/ 48105:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contact",
      function () {
        return __webpack_require__(6466);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 42871:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* eslint-disable global-require */ 
const { de: common  } = __webpack_require__(31668);
module.exports = {
    ...common
};


/***/ }),

/***/ 54606:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* eslint-disable global-require */ 
const { en: common  } = __webpack_require__(31668);
module.exports = {
    ...common,
    contact: __webpack_require__(98231)
};


/***/ }),

/***/ 59962:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* eslint-disable global-require */ 
module.exports = {
    en: __webpack_require__(54606),
    de: __webpack_require__(42871)
};


/***/ }),

/***/ 6466:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ contact; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/PageMeta/index.js
var PageMeta = __webpack_require__(93890);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/i18/index.js + 16 modules
var i18 = __webpack_require__(46003);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Hero/index.js + 1 modules
var Hero = __webpack_require__(69591);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Hero/Title.js
var Title = __webpack_require__(91319);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Section/index.js + 1 modules
var Section = __webpack_require__(93512);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Grid/index.js
var Grid = __webpack_require__(67478);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Link/index.js + 1 modules
var Link = __webpack_require__(25522);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Paragraph/index.js + 1 modules
var Paragraph = __webpack_require__(74229);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/classes.js
var classes = __webpack_require__(67924);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Heading/index.js + 1 modules
var Heading = __webpack_require__(42866);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/ContactElement/index.js






const ContactParagraph = (param)=>/*#__PURE__*/ {
    let { className ="" , type =1 , center =true , children , ...props } = param;
    return (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
        Tag: "div",
        center: center,
        className: (0,classes/* classes */.S)("contact-paragraph-type-".concat(type), className),
        ...props,
        children: children
    });
};
ContactParagraph.propTypes = {
    className: prop_types.string,
    type: (0,prop_types.oneOf)([
        1,
        2,
        3
    ]),
    center: prop_types.bool,
    children: prop_types.node.isRequired
};
const ContactTitle = (param)=>/*#__PURE__*/ {
    let { className ="" , type =1 , center =true , children , ...props } = param;
    return (0,jsx_runtime.jsx)(Heading/* default */.Z, {
        Tag: "div",
        center: center,
        className: (0,classes/* classes */.S)("contact-title-type-".concat(type), className),
        ...props,
        children: children
    });
};
ContactTitle.propTypes = {
    className: prop_types.string,
    type: (0,prop_types.oneOf)([
        1,
        2
    ]),
    center: prop_types.bool,
    children: prop_types.node.isRequired
};

// EXTERNAL MODULE: ./node_modules/@insightfulscience/shared-utils/fn/pipe.js
var pipe = __webpack_require__(75833);
// EXTERNAL MODULE: ./src/SiteLayout/index.js + 5 modules
var SiteLayout = __webpack_require__(3918);
// EXTERNAL MODULE: ./locales/contact-page/index.js
var contact_page = __webpack_require__(59962);
var contact_page_default = /*#__PURE__*/__webpack_require__.n(contact_page);
;// CONCATENATED MODULE: ./pages/contact.js













const Contact = ()=>{
    const [t] = (0,i18/* useLocale */.bU)("contact");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SiteLayout/* default */.Z, {
        hero: true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(PageMeta/* default */.ZP, {
                title: t("PAGE_TITLE"),
                description: t("META_DESCRIPTION"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PageMeta/* default.OGP */.ZP.OGP, {
                        title: t("PAGE_TITLE"),
                        description: t("META_DESCRIPTION"),
                        locale: t("META_LOCALE"),
                        type: t("META_TYPE"),
                        url: t("META_URL"),
                        image: t("META_IMAGE"),
                        imageSecureUrl: t("META_IMAGE_SECURE"),
                        siteName: t("META_SITE_NAME"),
                        articlePublisher: t("META_ARTICLE_PUBLISHER"),
                        isImageBaseUrl: true
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PageMeta/* default.Twitter */.ZP.Twitter, {
                        title: t("PAGE_TITLE"),
                        description: t("META_DESCRIPTION"),
                        site: t("META_TWITTER_SITE"),
                        card: t("META_TWITTER_CARD"),
                        image: t("META_TWITTER_IMAGE"),
                        creator: t("META_TWITTER_CREATOR"),
                        isImageBaseUrl: true
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PageMeta/* default.Canonical */.ZP.Canonical, {
                        href: t("META_CANONICAL")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PageMeta/* default.Author */.ZP.Author, {
                        content: t("META_AUTHOR")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Hero/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* default */.Z, {
                    children: t("HERO_TITLE")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* default */.Z, {
                spacing: {
                    py: 20
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Container */.W2, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
                        utility: {
                            justify: "center"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* Col */.JX, {
                            sm: 12,
                            md: 8,
                            lg: 5,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactTitle, {
                                    type: 1,
                                    children: t("CONTACT_HEADING")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactParagraph, {
                                    type: 1,
                                    children: t("CONTACT_CUSTOMERS")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactTitle, {
                                    type: 2,
                                    children: t("CONTACT_WORLDWIDE")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactParagraph, {
                                    type: 2,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                        target: "_blank",
                                        href: "https://support.snapgene.com/hc/en-us/requests/new?ticket_form_id=360000552331",
                                        children: t("CONTACT_SALES_AND_SUPPORT")
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContactParagraph, {
                                    type: 1,
                                    className: "mb-20",
                                    children: [
                                        t("CONTACT_ADDRESS_1"),
                                        " ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                        t("CONTACT_ADDRESS_2"),
                                        " ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                        t("CONTACT_ADDRESS_3")
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactTitle, {
                                    type: 2,
                                    children: t("CONTACT_CHINA_TITLE")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactParagraph, {
                                    type: 2,
                                    children: t("CONTACT_CHINA_OPTIONS")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactParagraph, {
                                    type: 3,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                        target: "_blank",
                                        href: "https://www.snapgene.cn/#contact",
                                        children: t("CONTACT_CHINA_SALES")
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactParagraph, {
                                    type: 3,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                        target: "_blank",
                                        href: "https://www.snapgene.cn/",
                                        children: t("CONTACT_CHINA_WEBSITE")
                                    })
                                })
                            ]
                        })
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var contact = ((0,pipe/* default */.Z)(Contact, (0,i18/* WithLocale */._t)({
    resources: (contact_page_default())
})));


/***/ }),

/***/ 91319:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Heading__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42866);
/* harmony import */ var _utils_classes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67924);
/* harmony import */ var _utils_pureProps__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(7820);
/* harmony import */ var _props_sx__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(23720);
/* harmony import */ var _props_spacing__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2349);
/* harmony import */ var _props_utility__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(18981);








const HeroTitle = (param)=>{
    let { align , color , className ="" , utility ={
        ..._props_utility__WEBPACK_IMPORTED_MODULE_6__/* .utilityProps */ .Gm
    } , sx ={
        ..._props_sx__WEBPACK_IMPORTED_MODULE_4__/* .sxProps */ .ET
    } , spacing ={
        ..._props_spacing__WEBPACK_IMPORTED_MODULE_5__/* .spacingProps */ .tF
    } , ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Heading__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        Tag: "h1",
        className: (0,_utils_classes__WEBPACK_IMPORTED_MODULE_3__/* .classes */ .S)("section-hero__title", ...(0,_props_utility__WEBPACK_IMPORTED_MODULE_6__/* .utilityClassName */ .b2)(utility), ...(0,_props_sx__WEBPACK_IMPORTED_MODULE_4__/* .sxClassName */ .ZA)((0,_utils_pureProps__WEBPACK_IMPORTED_MODULE_7__/* .deepMergeProps */ .p)({
            fontColor: color,
            textAlign: align
        }, (0,_utils_pureProps__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(sx)), true), ...(0,_props_spacing__WEBPACK_IMPORTED_MODULE_5__/* .spacingClassName */ .RB)(spacing), className),
        ...props
    });
};
HeroTitle.propTypes = {
    align: _props_sx__WEBPACK_IMPORTED_MODULE_4__/* .textAlignPropTypes */ .g4,
    ..._Heading__WEBPACK_IMPORTED_MODULE_2__/* ["default"].propTypes */ .Z.propTypes
};
/* harmony default export */ __webpack_exports__["Z"] = (HeroTitle);


/***/ }),

/***/ 69591:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Hero_Hero; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Section/index.js + 1 modules
var Section = __webpack_require__(93512);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Grid/index.js
var Grid = __webpack_require__(67478);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/classes.js
var classes = __webpack_require__(67924);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/spacing.js
var props_spacing = __webpack_require__(2349);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/sx.js
var props_sx = __webpack_require__(23720);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/utility.js
var props_utility = __webpack_require__(18981);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Hero/Hero.js









const Hero = (param)=>{
    let { align ="center" , children , color ="black--02" , utility ={
        ...props_utility/* utilityProps */.Gm
    } , sx ={
        ...props_sx/* sxProps */.ET
    } , spacing ={
        ...props_spacing/* spacingProps */.tF
    } , className ="" , backgroundImage  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* default */.Z, {
        className: (0,classes/* classes */.S)("section-hero", align && "section-hero-text-".concat(align), color && "section-hero-color-".concat(color), "".concat(backgroundImage ? "section-hero-custom-background" : ""), ...(0,props_utility/* utilityClassName */.b2)(utility), ...(0,props_sx/* sxClassName */.ZA)(sx), ...(0,props_spacing/* spacingClassName */.RB)(spacing), className),
        style: {
            ...backgroundImage && {
                backgroundImage: "url(".concat(backgroundImage, ")")
            }
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Container */.W2, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Col */.JX, {
                    children: children
                })
            })
        })
    });
};
Hero.propTypes = {
    align: props_sx/* textAlignPropTypes */.g4,
    className: prop_types.string,
    children: prop_types.node.isRequired,
    color: (0,prop_types.oneOf)([
        "1",
        "1--light",
        "2",
        "3",
        "4",
        "5",
        "6",
        "white",
        "black--02",
        "transparent",
        "gradient"
    ]),
    backgroundImage: prop_types.string,
    utility: props_utility/* utilityPropTypes */.pQ,
    sx: props_sx/* sxPropTypes */.I1,
    spacing: props_spacing/* spacingPropTypes */.Xj
};
/* harmony default export */ var Hero_Hero = (Hero);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Hero/index.js



/***/ }),

/***/ 93890:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony exports MetaTwitter, MetaOGP */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _insightfulscience_atomic_react_utils_AssetsProvider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(84154);





const Robots = (param)=>/*#__PURE__*/ {
    let { content =""  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
            name: "robots",
            content: content
        })
    });
};
Robots.propTypes = {
    content: prop_types__WEBPACK_IMPORTED_MODULE_4__.string
};
const Author = (param)=>/*#__PURE__*/ {
    let { content =""  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
            name: "author",
            content: content
        })
    });
};
Author.propTypes = {
    content: prop_types__WEBPACK_IMPORTED_MODULE_4__.string
};
const Canonical = (param)=>/*#__PURE__*/ {
    let { href  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
            rel: "canonical",
            href: href
        })
    });
};
Canonical.propTypes = {
    href: prop_types__WEBPACK_IMPORTED_MODULE_4__.string.isRequired
};
const CanonicalAlternate = (param)=>/*#__PURE__*/ {
    let { type ="text/html" , hrefLang , href , title =""  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
            rel: "alternate",
            type: type,
            hrefLang: hrefLang,
            href: href,
            title: title
        })
    });
};
CanonicalAlternate.propTypes = {
    type: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    hrefLang: prop_types__WEBPACK_IMPORTED_MODULE_4__.string.isRequired,
    href: prop_types__WEBPACK_IMPORTED_MODULE_4__.string.isRequired,
    title: prop_types__WEBPACK_IMPORTED_MODULE_4__.string
};
const MetaTwitter = (param)=>{
    let { card ="" , title ="" , description ="" , site ="" , image ="" , creator ="" , isImageBaseUrl =false  } = param;
    const baseUrl = isImageBaseUrl ? (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_insightfulscience_atomic_react_utils_AssetsProvider__WEBPACK_IMPORTED_MODULE_3__/* ["default"].context */ .Z.context) : "";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
        children: [
            title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:title",
                content: title
            }),
            description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:description",
                content: description
            }),
            card && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:card",
                content: card
            }),
            site && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:site",
                content: site
            }),
            image && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:image",
                content: "".concat(baseUrl).concat(image)
            }),
            creator && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:creator",
                content: creator
            })
        ]
    });
};
MetaTwitter.propTypes = {
    card: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    title: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    description: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    site: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    image: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    creator: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    isImageBaseUrl: prop_types__WEBPACK_IMPORTED_MODULE_4__.bool
};
const MetaOGP = (param)=>{
    let { isImageBaseUrl =false , title ="" , description ="" , locale ="" , type ="" , url ="" , image ="" , imageSecureUrl ="" , siteName ="" , articlePublisher =""  } = param;
    const baseUrl = isImageBaseUrl ? (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_insightfulscience_atomic_react_utils_AssetsProvider__WEBPACK_IMPORTED_MODULE_3__/* ["default"].context */ .Z.context) : "";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
        children: [
            title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:title",
                content: title
            }),
            description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:description",
                content: description
            }),
            locale && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:locale",
                content: locale
            }),
            type && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:type",
                content: type
            }),
            url && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:url",
                content: url
            }),
            image && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image",
                content: "".concat(baseUrl).concat(image)
            }),
            imageSecureUrl && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image:secure_url",
                content: "".concat(baseUrl).concat(imageSecureUrl)
            }),
            siteName && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:site_name",
                content: siteName
            }),
            articlePublisher && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "article:publisher",
                content: articlePublisher
            })
        ]
    });
};
MetaOGP.propTypes = {
    isImageBaseUrl: prop_types__WEBPACK_IMPORTED_MODULE_4__.bool,
    title: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    description: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    locale: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    type: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    url: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    image: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    imageSecureUrl: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    siteName: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    articlePublisher: prop_types__WEBPACK_IMPORTED_MODULE_4__.string
};
const PageMeta = (param)=>{
    let { title ="" , description ="" , children =""  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
                children: [
                    title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: title
                    }),
                    description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "description",
                        content: description
                    })
                ]
            }),
            children
        ]
    });
};
const CustomHead = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
        children: children
    });
};
CustomHead.propTypes = {
    children: prop_types__WEBPACK_IMPORTED_MODULE_4__.node
};
PageMeta.Robots = Robots;
PageMeta.Custom = CustomHead;
PageMeta.Canonical = Canonical;
PageMeta.CanonicalAlternate = CanonicalAlternate;
PageMeta.Author = Author;
PageMeta.Twitter = MetaTwitter;
PageMeta.OGP = MetaOGP;
PageMeta.propTypes = {
    title: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    description: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    children: prop_types__WEBPACK_IMPORTED_MODULE_4__.node
};
/* harmony default export */ __webpack_exports__["ZP"] = (PageMeta);


/***/ }),

/***/ 9008:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(83121)


/***/ }),

/***/ 98231:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"META_TITLE":"Contact GSL Biotech About SnapGene","META_DESCRIPTION":"We welcome your input. Please use this web page to ask a question, report a bug, or make a suggestion. Customer feedback helps us plan new features.","META_ARTICLE_PUBLISHER":"https://www.facebook.com/SnapGene","META_AUTHOR":"GSL Biotech LLC","META_SITE_NAME":"SnapGene","META_LOCALE":"en_US","META_TYPE":"article","META_IMAGE":"/images/snapgene/meta/preview-snapgene-dotmatics.png","META_IMAGE_SECURE":"/images/snapgene/meta/preview-snapgene-dotmatics.png","META_TWITTER_SITE":"@SnapGene","META_TWITTER_CARD":"summary_large_image","META_TWITTER_CREATOR":"@SnapGene","META_TWITTER_IMAGE":"/images/snapgene/meta/preview-snapgene-dotmatics.png","META_URL":"https://www.snapgene.com/contact","META_CANONICAL":"https://www.snapgene.com/contact","PAGE_TITLE":"Contact GSL Biotech About SnapGene","HERO_TITLE":"Contact","CONTACT_HEADING":"We want to hear from you","CONTACT_CUSTOMERS":"Whether you’re a customer with a question or comment, or a member of the press, or a business interested in working with us, please let us know how we can help.","CONTACT_WORLDWIDE":"Worldwide Inquiries","CONTACT_SALES_AND_SUPPORT":"Contact Sales and Support »","CONTACT_ADDRESS_1":"GSL Biotech LLC","CONTACT_ADDRESS_2":"225 Franklin Street. Fl. 26","CONTACT_ADDRESS_3":"Boston, MA 02110","CONTACT_CHINA_TITLE":"China Sales","CONTACT_CHINA_OPTIONS":"Local sales options are available for China","CONTACT_CHINA_SALES":"Contact China Sales »","CONTACT_CHINA_WEBSITE":"Chinese Website »"}');

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [6319,5606,8124,2458,3918,9774,2888,179], function() { return __webpack_exec__(25436), __webpack_exec__(48105); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);